module.exports = __webpack_public_path__ + "static/media/contactus-banner-2.4c89e8c5.jpg";